import { getOrder } from 'graphql/ron/queries';
import { UseQueryOptions, useQuery } from 'react-query';

import { GQLGetOrder } from 'services/querys/orders';

export const ronGetOrderQueryKey = (orderId: string) => ['RON-getOrder', orderId];

export const useRONGetOrder = (
  orderId: string,
  queryConfig?: UseQueryOptions<GQLGetOrder, unknown, GQLGetOrder, any>
) => {
  const getRONOrder = useQuery(ronGetOrderQueryKey(orderId), () => getOrder(orderId), {
    ...queryConfig,
    enabled: !!orderId && queryConfig?.enabled !== false,
    refetchOnWindowFocus: false,
  });

  return getRONOrder;
};
